import { render, staticRenderFns } from "./IconesRedesSociais.vue?vue&type=template&id=24182ced"
import script from "./IconesRedesSociais.vue?vue&type=script&lang=js"
export * from "./IconesRedesSociais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports